export default "__VITE_ASSET__UhFU6mD5__"